exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".page-completed .card-img {\n  max-width: 180px;\n  max-height: 180px;\n  margin: 0.8rem 0;\n}", "", {"version":3,"sources":["/home/runner/work/hive-life-proof-portal/hive-life-proof-portal/src/views/Completed.vue"],"names":[],"mappings":"AAEE;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;CADJ","file":"Completed.vue?vue&type=style&index=0&id=57a5a001&lang=scss","sourcesContent":["\n.page-completed {\n  .card-img {\n    max-width: 180px;\n    max-height: 180px;\n    margin: .8rem 0;\n  }\n}\n"],"sourceRoot":""}]);

// exports
